 <template>
  <tr class="row-details">
    <td colspan="7" style="padding: 0;">
      <table class="table table-inline table-details">
        <tbody>
          <tr>
            <td>
              <h4>Encaissement</h4>
              <div><b>Type :</b> {{ cashing.decoded_type }}</div>
              <div>
                <b>Client :</b>
                <router-link :to="{ name: 'customer', params: { id: cashing.customer_id } }">{{ cashing.customer.name }}</router-link>
              </div>
              <div><b>Créé le :</b> {{ cashing.created_at | moment-date }}</div>
              <div v-if="this.user"><b>Par l'utilisateur :</b> {{ this.user.email }}</div>
              <div v-if="cashing.creating_agency_id"><b>Pour l'agence :</b> {{ agencyNameOf(cashing.creating_agency_id ) }}</div>
              <div><b>Notification e-mail :</b> {{ cashing.email }}</div>
            </td>
            <td>
              <h4>Détail</h4>
              <div v-if="cashing.type == 'free'">
                <ul>
                  <li v-for="(entry, index) in cashing.entries">
                    <b>{{ organizationNameOf(entry.organization_id) }} :</b> <span>{{ (entry.ttc_amount / 100).toFixed(2) }}€</span>
                  </li>
                </ul>
              </div>
              <div v-else-if="cashing.type == 'invoices'">
                <ul>
                  <li v-for="(invoice, index) in cashing.invoices">
                    <b>Facture n° {{ invoice.erp_id }} :</b> <span>{{ (invoice.ttc_amount / 100).toFixed(2) }}€</span>
                  </li>
                </ul>
              </div>
            </td>
            <td>
              <h4>Paiement</h4>
              <div v-if="cashing.payment_status != 'paid'">{{ cashing.decoded_payment_status }}</div>
              <payment-item 
                  v-else-if="cashing.payments && cashing.payments.length > 0"
                  :payment="cashing.payments[0]">
              </payment-item>
            </td>
          </tr>
        </tbody>
      </table>
    </td>
  </tr>
</template>

<script type="text/babel">
  import {mapState, mapActions} from 'vuex'
  import PaymentItem from '../Payment/Item'
  
  export default {
    props: ['cashing'],

    components: {
      PaymentItem,
    },

    data () {
      return {
          user: null
      }
    },

    created () {
      // Cashing user
      this.getUser(this.cashing.user_id)
          .then(response => { this.user = response.data.user })
      
    },

    computed: {
      ...mapState(['agencies']),
    },

    methods: {
        ...mapActions(['getUser']),

        agencyNameOf(agencyId) {
          let found = _.find(this.agencies, (agency) => agency.id == agencyId)

          if (found != undefined)
            return found.name

          return null
        },

        organizationNameOf(organization_id){
          if (organization_id == 1)
            return "Sofradom"
          else if (organization_id == 2) {
            return "SDM"
          }
          else if (organization_id == 3) {
            return "ABC+"
          }
          else {
            return "N/A"
          }
        },
    }
  }

</script>

<style lang="scss" scoped>
  .table-details {
    margin: 0;

    tbody {
      tr {
        td {
          padding: 10px 20px 20px;
          vertical-align: top;
          width: auto;
          ul {
            padding: 0;
            li {
              padding: 0;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// client/components/Cash/ItemDetail.vue